<template>
  <b-container v-if="isAuthenticated">
    <div class="payment-request-heading">
      <h2 class="heading">Payment Requests</h2>
      <div class="pr-button-container">
        <div class="pr-btn-container">
          <button
            class="create-r-btn"
            id="create-payment-request"
            v-if="
              canCreateStandardPaymentRequest ||
                canCreateRecurringPaymentRequest
            "
            @click.prevent="openCreatePaymentRequestModal()"
          >
            + {{ "   " }}Create Request
          </button>
          <button
            class="dropdown-r-btn"
            @click="
              togglePaymentRequestionOptions = !togglePaymentRequestionOptions
            "
          >
            <i
              class="fa-solid fa-caret-down"
              v-if="!togglePaymentRequestionOptions"
            ></i>
            <i class="fa-solid fa-caret-up" v-else></i>
          </button>
          <div class="pr-options" v-if="togglePaymentRequestionOptions">
            <button @click="openCreatePaymentRequestModal('standard')">
              Standard
            </button>
            <button @click="openCreatePaymentRequestModal('recurring')">
              Recurring
            </button>
          </div>
        </div>

        <button
          v-if="false"
          class="multiple-file"
          @click="openPaymentUploadFileRequestDialog"
        >
          Create Multiple Payments
        </button>
      </div>
    </div>
    <hr />
    <div class="pr-filter-container">
      <div
        v-for="(item, index) in filterStatuses"
        @click="selectFilterStatus(index, item.value)"
        :key="index"
        :class="[
          'pr-filter-status',
          item.selected ? 'pr-selected' : null,
          item.selected ? 'pr-color-white' : null,
          index === 0 ? 'pr-first' : null,
          index === filterStatuses.length - 1 ? 'pr-last' : null
        ]"
      >
        {{ item.value }}
      </div>
    </div>

    <div class="pr-search-container">
      <v-select
        v-if="false"
        label="Category"
        class="pr-select-category"
        solo
        flat
        dense
      ></v-select>
      <b-form-input
        v-model="search"
        placeholder="Search"
        class="pr-advance-search"
      ></b-form-input>
      <button @click="showPaymentRequestSearch">
        Advance Search
      </button>
    </div>

    <PaymentRequestSearch
      v-if="isShowPayReqSearch"
      @retrievePaymentRequest="retrievePaymentRequestInfo"
    />

    <PaymentRequestTable
      :search="search"
      @viewDetailedPaymentRequest="openDetailedPaymentRequestModal"
      :items="filteredRequests"
      :loading="isLoadingList"
      @changedData="saveChangedTableData"
      ref="paymentRequestTable"
    />

    <CreatePaymentRequestModal
      :createDialog="isShowCreatePaymentRequestDialog"
      v-model="paymentRequestType"
      @eCloseCreatePaymentRequestModal="closeCreatePaymentRequestModal"
    />

    <PaymentUpload
      :Dialog="isShowPaymentUploadFileRequestDialog"
      @eClosePaymentUploadFileRequestDialog="
        closePaymentUploadFileRequestDialog
      "
    />
    <DetailedPaymentRequestModal
      v-model="detailedPaymentRequestModal_Model"
      :dialog="isShowDetailedPaymentRequestDialog"
      @closeDetailedRequestModal="closeDetailedPaymentRequestModal"
      @eReloadDetailedModal="openDetailedPaymentRequestModal"
    />
  </b-container>
</template>
<style>
.payment-request-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
  /* border: 1px solid black; */
}

.payment-request-heading .heading {
  color: #222325;
  font-family: "Open Sans";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
}
.payment-request-heading .heading .dropdown,
.pr-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.multiple-file,
.create-r-btn,
.dropdown-r-btn {
  height: 40px;
  background-color: #6b68e8;
  color: #ffffff;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  padding: 0 10px;
}
.pr-btn-container {
  position: relative;
}
.pr-options button {
  color: white;
  background-color: #6b68e8;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.7rem;
  border-radius: 4px;
}
.pr-options {
  border-radius: 4px;
  position: absolute;
  width: 150px;
  right: 0;
  top: 50px;
  padding: 1rem 5px;
  background: #f7f7ff;
}
.payment-request-heading .multiple-file {
  margin-left: 1rem;
  border-radius: 4px;
}
.pr-search-container {
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  height: 72px;
  border-radius: 4px;
  background-color: #f7f7ff;
  margin-bottom: 1rem;
  /* box-shadow: 0 8px 16px 0 rgba(49, 51, 80, 0.2); */
}
.pr-search-container button {
  height: 16px;
  width: 115px;
  color: #5a4db6;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
}

.pr-select-category,
.pr-advance-search {
  margin-right: 1rem !important;
  box-sizing: border-box !important;
  height: 40.5px !important;
  max-width: 350px !important;
  border: 0.5px solid #d8d8e4 !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
}

.pr-filter-container {
  display: flex;
  margin-bottom: 1rem;
}
.pr-filter-status {
  cursor: pointer;
  height: 40px;
  width: 141px;
  background-color: #f7f7ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #6a63eb;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}
.create-r-btn {
  border-radius: 4px 0 0 4px;
  margin-right: 1px;
}
.dropdown-r-btn {
  border-radius: 0 4px 4px 0;
}
.pr-color-white {
  color: #ffffff;
}
.pr-selected {
  background-color: #6c6ce5;
}

.pr-first {
  border-radius: 4px 0 0 4px;
}
.pr-last {
  border-radius: 0 4px 4px 0;
}
.pr-search-container .v-text-field__details {
  display: none;
}
.pr-search-container .v-input__slot {
  margin: none;
}

@media screen and (max-width: 550px) {
  .payment-request-heading,
  .pr-button-container {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .payment-request-heading .heading {
    margin-bottom: 1rem;
  }

  .pr-filter-container {
    flex-direction: column;
  }
  .pr-filter-status {
    width: 100%;
  }
}
</style>
<script>
import PaymentRequestTable from "@/components/tables/PaymentRequestTable.vue";
import CreatePaymentRequestModal from "@/components/widgets/CreatePaymentRequestModal.vue";
import DetailedPaymentRequestModal from "@/components/widgets/DetailedPaymentRequestModal.vue";
import PaymentRequestSearch from "@/views/pages/merchant/paymentrequest/PaymentRequestSearch.vue";
import PaymentUpload from "@/views/pages/merchant/paymentrequest/PaymentUploadFileRequestModal.vue";
import PaymentRequestPerimissionsMixin from "@/components/paymentrequest/PaymentRequestPermissionsMixin.js";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { API, graphqlOperation } from "aws-amplify";
import AppSettings from "@/appsettings/appsettings.js";
import dayjs from "dayjs";

const PAYMENT_REQUEST_ID_SEARCH_CATEGORY = "PaymentRequestId";
const DEFAULT_PAGINATION_LIMIT = AppSettings.paymentRequestPaginationLimit;
const DEFAULT_NUMBER_OF_DAYS_IN_THE_PAST =
  AppSettings.paymentRequestTableDefaultDate.daysInThePast;
const DEFAULT_GETPAYMENTREQUEST_QUERY = ` query GetPaymentRequest(
    $body: QueryGetPaymentRequestInput!
  ){
      getPaymentRequest(params: $body){
        paymentRequestList{
          orderNumber
          customerFirstName
          customerLastName
          email
          isEmailSent
          currencyText
          amount
          isRecurring
          isPaymentSetup
          paymentRequestId
          createdDate
          recurringStatus
          expiryDate
          sendDate
        },
        nextToken
      }
  }
`;
const INDIVIDUAL_GETPAYMENTREQUEST_QUERY = ` query GetPaymentRequest(
    $body: QueryGetPaymentRequestInput!
  ){
      getPaymentRequest(params: $body){
        paymentRequestList{
          orderNumber
          customerFirstName
          customerLastName
          email
          isEmailSent
          currencyText
          amount
          isRecurring
          isPaymentSetup
          setupDate
          paymentRequestId
          createdBy
          createdDate
          emailStatus
          emailSentDate
          initialPaymentAmount
          expiryDate
          reason
          sendDate
          executionDate
          frequency
          period
          currentPeriod
          recurringStatus
        }
      }
  }
`;

export default {
  mixins: [PaymentRequestPerimissionsMixin],
  components: {
    PaymentRequestTable,
    CreatePaymentRequestModal,
    DetailedPaymentRequestModal,
    PaymentRequestSearch,
    PaymentUpload
  },
  data() {
    return {
      filterStatuses: [
        { value: "All", selected: true },
        { value: "Scheduled", selected: false },
        { value: "Unpaid", selected: false },
        { value: "Paid", selected: false },
        { value: "Cancelled", selected: false }
      ],
      paymentRequestType: null,
      togglePaymentRequestionOptions: false,
      isShowCreatePaymentRequestDialog: false,
      search: "",
      isShowPayReqSearch: false,
      detailedPaymentRequestModal_Model: {},
      isShowDetailedPaymentRequestDialog: false,
      isShowPaymentUploadFileRequestDialog: false,
      filterStatus: null,
      paymentRequests: [],
      nextToken: null,
      isLoadingList: false,
      defaultSearchInfo: {
        searchCategory: "CreatedDate",
        paymentRequestId: "",
        dateRange: {
          startDate: this.defaultDate().startDate,
          endDate: this.defaultDate().endDate
        }
      },
      currentSearchInfo: null
    };
  },
  computed: {
    filteredRequests() {
      if (!this.filterStatus) return this.paymentRequests;
      const choice = {
        Unpaid: this.unpaidFilter,
        Paid: this.paidFilter,
        Cancelled: this.cancelledFilter,
        Scheduled: this.scheduleFilter,
        All: this.originalRequests
      };
      return choice[this.filterStatus]();
    }
  },
  methods: {
    currencyFormatter(number) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });

      return formatter.format(number);
    },
    originalRequests() {
      return this.paymentRequests;
    },
    paidFilter() {
      return this.paymentRequests.filter(pr => pr.paymentSetup === "Yes");
    },
    unpaidFilter() {
      return this.paymentRequests.filter(pr => pr.paymentSetup === "No");
    },
    cancelledFilter() {
      return this.paymentRequests.filter(
        pr => pr.recurringStatus === "Cancelled"
      );
    },
    scheduleFilter() {
      return this.paymentRequests.filter(
        pr => pr.sendDate !== null && dayjs(pr.sendDate).isAfter(dayjs())
      );
    },
    selectFilterStatus(itemIndex, val) {
      this.filterStatuses = this.filterStatuses.map((item, index) =>
        index === itemIndex
          ? { ...item, selected: true }
          : { ...item, selected: false }
      );
      this.filterStatus = val;
    },
    showPaymentRequestSearch() {
      this.isShowPayReqSearch = !this.isShowPayReqSearch;
    },
    async openDetailedPaymentRequestModal(item) {
      let individualTransactionInfo = await this.retrieveIndividualTransactionInfo(
        item.paymentRequestId
      );
      this.detailedPaymentRequestModal_Model = Object.assign(
        {},
        individualTransactionInfo
      );
      this.isShowDetailedPaymentRequestDialog = true;
    },
    closeDetailedPaymentRequestModal() {
      this.isShowDetailedPaymentRequestDialog = false;
      this.$nextTick(() => {
        this.detailedPaymentRequestModal_Model = {};
      });
    },
    openCreatePaymentRequestModal(option) {
      if (option) this.paymentRequestType = option;
      this.isShowCreatePaymentRequestDialog = true;
    },
    closeCreatePaymentRequestModal() {
      this.isShowCreatePaymentRequestDialog = false;
    },
    openPaymentUploadFileRequestDialog() {
      this.isShowPaymentUploadFileRequestDialog = true;
    },
    closePaymentUploadFileRequestDialog() {
      this.isShowPaymentUploadFileRequestDialog = false;
    },
    async retrieveIndividualTransactionInfo(paymentRequestId) {
      let individualSearchInfo = {
        searchCategory: PAYMENT_REQUEST_ID_SEARCH_CATEGORY,
        paymentRequestId: paymentRequestId
      };

      let tempRequest = await this.paymentRequestRetrieval(
        INDIVIDUAL_GETPAYMENTREQUEST_QUERY,
        individualSearchInfo,
        this.formatInputData_Projection_2
      );
      return tempRequest.paymentRequestList[0];
    },
    async retrievePaymentRequestInfo(searchInfo) {
      let formattedSearchInfo = this.formatSearchInfo(searchInfo);
      this.nextToken = null;
      this.$refs.paymentRequestTable.resetTable();

      let tempRequest = await this.paymentRequestRetrieval(
        DEFAULT_GETPAYMENTREQUEST_QUERY,
        formattedSearchInfo,
        this.formatInputData_Projection_1
      );

      this.currentSearchInfo = formattedSearchInfo;
      this.paymentRequests = tempRequest.paymentRequestList;
      this.nextToken = tempRequest.nextToken;
    },
    async getPaymentRequest(getPaymentRequestQuery, searchInfo) {
      let tenantAlias = await this.getMerchantId();
      let filter = {
        limit: DEFAULT_PAGINATION_LIMIT,
        nextToken: this.nextToken
      };

      let searchCategory = searchInfo.searchCategory;
      let paymentRequestId = searchInfo.paymentRequestId;
      let dateRange = searchInfo.dateRange;

      const queryGetPaymentRequestInput = {
        tenantAlias,
        searchCategory,
        paymentRequestId,
        dateRange,
        filter
      };

      try {
        this.isLoadingList = true;
        const response = await API.graphql(
          graphqlOperation(getPaymentRequestQuery, {
            body: queryGetPaymentRequestInput
          })
        );

        if (!response.data.getPaymentRequest)
          throw new Error("Response Is Empty");

        let retrievedPaymentRequestList =
          response.data.getPaymentRequest.paymentRequestList;

        let retrievedNextToken = response.data.getPaymentRequest.nextToken;

        this.isLoadingList = false;
        return {
          paymentRequestList: retrievedPaymentRequestList,
          nextToken: retrievedNextToken
        };
      } catch (err) {
        this.isLoadingList = false;
        this.$logger.error(err);
        return {
          paymentRequestList: [],
          nextToken: null
        };
      }
    },
    formatInputData_Projection_1(inputData) {
      return {
        expiryDate: inputData.expiryDate,
        recurringStatus: inputData.recurringStatus,
        sendDate: inputData.sendDate,
        createdDate: inputData.createdDate,
        orderNumber: inputData.orderNumber,
        customerName: `${inputData.customerFirstName} ${inputData.customerLastName}`,
        email: inputData.email,
        emailSent: inputData.isEmailSent ? "Sent" : "Not Sent",
        amount_currency: `${this.currencyFormatter(inputData.amount)} ${
          inputData.currencyText ? inputData.currencyText : ""
        }`,
        currencyText: inputData.currencyText,
        currency: inputData.currency,
        amount: inputData.amount,
        paymentType: inputData.isRecurring ? "Recurring" : "Standard",
        paymentSetup: inputData.isPaymentSetup ? "Yes" : "No",
        paymentRequestId: inputData.paymentRequestId
      };
    },
    formatInputData_Projection_2(inputData) {
      return {
        ...this.formatInputData_Projection_1(inputData),
        setupDate: inputData.setupDate,
        createdBy: inputData.createdBy,
        createdDate: inputData.createdDate,
        emailStatus: inputData.emailStatus,
        initialPaymentAmount: `${
          inputData.initialPaymentAmount
            ? `${this.currencyFormatter(inputData.initialPaymentAmount)}`
            : `$0.00`
        } ${inputData.currencyText ? inputData.currencyText : ""}`,
        expiryDate: inputData.expiryDate,
        reason: inputData.reason,
        sendDate: inputData.sendDate,
        executionDate: inputData.executionDate,
        frequency: inputData.frequency,
        period:
          !!inputData.period && inputData.period < 0
            ? "Continuous"
            : inputData.period,
        currentPeriod: inputData.currentPeriod,
        recurringStatus: inputData.recurringStatus
      };
    },
    formatSearchInfo(searchInfo) {
      return {
        searchCategory: searchInfo.searchCategory,
        paymentRequestId: searchInfo.paymentRequestId,
        dateRange: {
          startDate: searchInfo.startDate,
          endDate: searchInfo.endDate
        }
      };
    },
    formatDate(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1; //January starts at 0

      if (day < 10) day = `0${day}`;
      if (month < 10) month = `0${month}`;
      return `${date.getFullYear() + "-" + month + "-" + day}`;
    },
    defaultDate() {
      let date = new Date();
      let today = this.formatDate(date);

      date.setDate(date.getDate() - DEFAULT_NUMBER_OF_DAYS_IN_THE_PAST);
      let oneWeekAgo = this.formatDate(date);

      return {
        startDate: oneWeekAgo,
        endDate: today
      };
    },
    async saveChangedTableData(event) {
      if (event.page == event.pageCount && event.pageStop >= event.itemsPerPage)
        this.attemptToLoadMoreItems(this.currentSearchInfo);
    },
    async attemptToLoadMoreItems(currentSearchInfo) {
      if (this.nextToken) {
        let tempRequest = await this.paymentRequestRetrieval(
          DEFAULT_GETPAYMENTREQUEST_QUERY,
          currentSearchInfo,
          this.formatInputData_Projection_1
        );
        this.paymentRequests = this.paymentRequests.concat(
          tempRequest.paymentRequestList
        );
        this.nextToken = tempRequest.nextToken;
      }
    },
    async paymentRequestRetrieval(
      paymentRequestQuery,
      searchInfo,
      formatFunction
    ) {
      let tempRequest = await this.getPaymentRequest(
        paymentRequestQuery,
        searchInfo
      );
      let formattedList = tempRequest.paymentRequestList.map(formatFunction);
      return {
        paymentRequestList: formattedList,
        nextToken: tempRequest.nextToken
      };
    },
    async getPrRequest() {
      let tempRequest = await this.paymentRequestRetrieval(
        DEFAULT_GETPAYMENTREQUEST_QUERY,
        this.defaultSearchInfo,
        this.formatInputData_Projection_1
      );
      this.currentSearchInfo = this.defaultSearchInfo;
      this.paymentRequests = tempRequest.paymentRequestList;
      this.nextToken = tempRequest.nextToken;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Payment Requests" }]);
  },
  async created() {
    await this.getPrRequest();
    if (!this.$route.params.option) return;
    if (this.$route.params.option != "payment") {
      const intentId = this.$route.params.option;
      this.openDetailedPaymentRequestModal({ paymentRequestId: intentId });
      return;
    }

    if (this.$route.params.subOption) {
      this.paymentRequestType = this.$route.params.subOption;
    }
    this.openCreatePaymentRequestModal();
  }
};
</script>
